module.exports = __webpack_public_path__ + "img/improve_section_right_top.fc9cac14.png";